import React from 'react';
import { Grid, Label, Form, TextArea, Dropdown, Checkbox, Table, Button } from 'semantic-ui-react';
import InputField from 'common/InputField';
import ScriptEditor from './ScriptEditor';
import BlueprintChooser from 'common/BlueprintChooser';
import { equipmentLocationOptions } from 'common/options';


const CreatureEditor = function(props) {
  const cr = props.creature;
  const change = props.onChange;


  const addEquip = () => {
    const newEquip = {
       ID: '',
       Type: 'left'
    };

    change('Equipment')([...cr.Equipment, newEquip]);
  }

  const delEquip = (i) => {
    change('Equipment')(cr.Equipment.filter((e,idx) => i !== idx));
  }

  return (
  <React.Fragment>
    <Grid.Row>
      <Grid.Column width={16}>
        <Form>
          <Label>Description</Label>
          <TextArea value={cr.Description}
                    onChange={(e,d) => change('Description')(d.value)}
                    placeholder='Creature Description'/>
        </Form>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={3}>
        <InputField value={cr.MaxHP}
                    onChange={change('MaxHP')}
                    label='HP'
                    placeholder='HP'
                    fluid
                    type='int' />
      </Grid.Column>
      <Grid.Column width={3}>
        <InputField value={cr.MaxMP}
                    onChange={change('MaxMP')}
                    label='MP'
                    placeholder='0'
                    fluid
                    optional
                    type='int' />
      </Grid.Column>
      <Grid.Column width={3}>
        <InputField value={cr.STR}
                    onChange={change('STR')}
                    label='STR'
                    placeholder='0'
                    fluid
                    optional
                    type='int' />
      </Grid.Column>
      <Grid.Column width={3}>
        <InputField value={cr.DEX}
                    onChange={change('DEX')}
                    label='DEX'
                    placeholder='0'
                    fluid
                    optional
                    type='int' />
      </Grid.Column>
      <Grid.Column width={3}>
        <InputField value={cr.INT}
                    onChange={change('INT')}
                    label='INT'
                    placeholder='0'
                    fluid
                    optional
                    type='int' />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={3}>
        <InputField value={cr.WTR}
                    onChange={change('WTR')}
                    label='WTR'
                    placeholder='0'
                    fluid
                    optional
                    type='int' />
      </Grid.Column>
      <Grid.Column width={3}>
        <InputField value={cr.ERT}
                    onChange={change('ERT')}
                    label='ERT'
                    placeholder='0'
                    fluid
                    optional
                    type='int' />
      </Grid.Column>
      <Grid.Column width={3}>
        <InputField value={cr.FIR}
                    onChange={change('FIR')}
                    label='FIR'
                    placeholder='0'
                    fluid
                    optional
                    type='int' />
      </Grid.Column>
      <Grid.Column width={3}>
        <InputField value={cr.AIR}
                    onChange={change('AIR')}
                    label='AIR'
                    placeholder='0'
                    fluid
                    optional
                    type='int' />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={3}>
        <InputField value={cr.ATK}
                    onChange={change('ATK')}
                    label='ATK'
                    placeholder='0'
                    fluid
                    optional
                    type='int' />
      </Grid.Column>
      <Grid.Column width={3}>
        <InputField value={cr.ARC}
                    onChange={change('ARC')}
                    label='ARC'
                    placeholder='0'
                    fluid
                    optional
                    type='int' />
      </Grid.Column>
      <Grid.Column width={3}>
        <InputField value={cr.DEF}
                    onChange={change('DEF')}
                    label='DEF'
                    placeholder='0'
                    fluid
                    optional
                    type='int' />
      </Grid.Column>
      <Grid.Column width={3}>
        <InputField value={cr.LOR}
                    onChange={change('LOR')}
                    label='LOR'
                    placeholder='0'
                    fluid
                    optional
                    type='int' />
      </Grid.Column>
      <Grid.Column width={3}>
        <InputField value={cr.THF}
                    onChange={change('THF')}
                    label='THF'
                    placeholder='0'
                    fluid
                    optional
                    type='int' />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={3}>
        <InputField value={cr.LUK}
                    onChange={change('LUK')}
                    label='LUK'
                    placeholder='0'
                    fluid
                    optional
                    type='int' />
      </Grid.Column>
      <Grid.Column width={3}>
        <InputField value={cr.AP}
                    onChange={change('AP')}
                    label='AP'
                    placeholder='AP'
                    fluid
                    type='int' />
      </Grid.Column>
      <Grid.Column width={3}>
        <InputField value={cr.XP}
                    onChange={change('XP')}
                    label='XP'
                    placeholder='XP'
                    fluid
                    type='int' />
      </Grid.Column>
      <Grid.Column width={3}>
        <Checkbox label='Enemy'
                  checked={cr.Enemy}
                  onChange={() => change('Enemy')(!cr.Enemy)} />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={8}>
        <Label>OnCreate</Label>
        <ScriptEditor src={cr.OnCreate} onSave={change('OnCreate')} />
      </Grid.Column>
      <Grid.Column width={8}>
        <Label>OnDeath</Label>
        <ScriptEditor src={cr.OnDeath} onSave={change('OnDeath')} />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={8}>
        <Label>OnRound</Label>
        <ScriptEditor src={cr.OnRound} onSave={change('OnRound')} />
      </Grid.Column>
      <Grid.Column width={8}>
        <Label>OnCombatRound</Label>
        <ScriptEditor src={cr.OnCombatRound} onSave={change('OnCombatRound')} />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={8}>
        <Label>OnDamaged</Label>
        <ScriptEditor src={cr.OnDamaged} onSave={change('OnDamaged')} />
      </Grid.Column>
      <Grid.Column width={8}>
        <Label>OnInteract</Label>
        <ScriptEditor src={cr.OnInteract} onSave={change('OnInteract')} />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={8}>
        <Label>OnSee</Label>
        <ScriptEditor src={cr.OnSee} onSave={change('OnSee')} />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={16}>
        <Label>Skills</Label>
        <BlueprintChooser blueprints={props.blueprints.filter(b => b._type === 'Skill')}
                          multiple
                          fluid
                          selected={cr.Skill}
                          onChange={change('Skill')} />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={16}>
        <Label>Spells</Label>
        <BlueprintChooser blueprints={props.blueprints.filter(b => b._type === 'Spell')}
                          multiple
                          fluid
                          selected={cr.Spell}
                          onChange={change('Spell')} />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={16}>
        <Label>Items</Label>
        <BlueprintChooser blueprints={props.blueprints.filter(b => b._type === 'Item')}
                          multiple
                          fluid
                          selected={cr.Item}
                          onChange={change('Item')} />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Table celled striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Item ID</Table.HeaderCell>
            <Table.HeaderCell>Location</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
        {cr.Equipment.map((e, i) => {

          const changeEquip = function(f) {
            return function(val) {
              var thisEquip = {...e};
              var newEquip = [...cr.Equipment];
              thisEquip[f] = val;
              newEquip[i] = thisEquip;
              change('Equipment')(newEquip);
            };
          }

          return (
            <Table.Row>
              <Table.Cell>
                <BlueprintChooser blueprints={props.blueprints.filter(bp => bp._type === 'Item')}
                                  selected={e.ID}
                                  fluid
                                  onChange={changeEquip('ID')} />
              </Table.Cell>
              <Table.Cell>
                <Dropdown options={equipmentLocationOptions}
                          value={e.Type}
                          onChange={(e,d) => changeEquip('Type')(d.value)}
                          selection
                          search />
                <Button icon='delete' color='red' onClick={() => delEquip(i)} />
              </Table.Cell>
            </Table.Row>
          );
        })}
        </Table.Body>
      </Table>
      <Button icon='add' content='Add equipped item' onClick={addEquip} />
    </Grid.Row>
  </React.Fragment>
  );
}



export default CreatureEditor;
